;(function($, window, document, undefined) {
    var pluginName = 'rkasGallery';
    var defaults = {
        defaultEaseFn: 'cubic-bezier(0.645, 0.045, 0.355, 1.000)',
        prevArrow: '<button class="gallery__arrow gallery__arrow--left" aria-label="previus slide">' + rkas.icon.render('#arrow-left') + '</button>',
        nextArrow: '<button class="gallery__arrow gallery__arrow--right" aria-label="next slide">' + rkas.icon.render('#arrow-right') + '</button>'
    };
    var initSelector = '.gallery';

    /**
     * Gallery.
     *
     * @class
     * @param {HTMLElement} element - The HTML element the Gallery should be bound to.
     * @param {Object} options - An option map.
     */
    function Gallery(element, options) {
        this.element = element;
        this.$element = $(this.element);
        this.$slider = this.$element.find(".gallery__slider");
        this.$nav = this.$element.find(".gallery__nav");
        this.options = $.extend({}, defaults, options);
        this._defaults = defaults;
        this._name = pluginName;

        this.init();
    }

    /**
     * Initialize the plugin.
     *
     * @function init
     * @returns {void}
     */
    Gallery.prototype.init = function() {
        if (!this.$element.hasClass('slick-initialized')) {
            this.bindEvents();
            this.initSlick();
        }
    };

    /**
     * Initialize slick plugin.
     *
     * @function initSlick
     * @returns {void}
     */
    Gallery.prototype.initSlick = function() {
        var dataDefaultSlides = this.$element.data('slides-default');
        var slidesDefault = dataDefaultSlides == undefined ? 1 : parseInt(dataDefaultSlides);

        this.$slider.slick({
            dots: false,
            infinite: false,
            autoplay: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            draggable: true,
            cssEase: this.options.defaultEaseFn,
            useTransform: true,
            speed: 500,
            zIndex: 1,
            prevArrow: this.options.prevArrow,
            nextArrow: this.options.nextArrow,
            asNavFor: '.gallery__nav'
            // responsive: this.setResponsive(this.$element)
            // slidesToShow: 1,
            // slidesToScroll: 1,
            // arrows: false,
            // fade: true,
            // asNavFor: '.gallery__nav'
        });

        this.$nav.slick({
            dots: false,
            infinite: false,
            autoplay: false,
            mobileFirst: true,
            variableWidth: true,
            slidesToShow: 1,
            cssEase: this.options.defaultEaseFn,
            useTransform: true,
            speed: 500,
            zIndex: 1,
            focusOnSelect: true,
            asNavFor: '.gallery__slider',
            centerMode: true,
            arrows: false,
            swipeToSlide: true
        });
    };



    /**
     * Bind events.
     *
     * @function bindEvents
     * @returns {void}
     */
    Gallery.prototype.bindEvents = function() {
        var that = this;

        $(document).on('refresh.rkas.carousel', function(event, target) {
            if (that.$slider.hasClass('slick-initialized') && target && $.contains(target, that.element)) {
                that.$slider.slick('refresh');
            }
        });
    };

    /**
     * Set responsive config for slick.
     *
     * @function setResponsive
     * @returns {Object[]} Array of objects with breakpoints config.
     */
    Gallery.prototype.setResponsive = function() {
        var breakpoints = {
            xs: {
                width: 320,
                slides: 5
            },
            sm: {
                width: 600,
                slides: 7
            },
            md: {
                width: 1024,
                slides: 9
            },
            lg: {
                width: 1200,
                slides: 9
            }
        };
        var conf = [];

        for (var key in breakpoints) {
            var slide = {
                settings: {
                    draggable: true,
                    speed: 500
                }
            };

            if (breakpoints.hasOwnProperty(key)) {
                var dataDefault =  breakpoints[key];
                var dataBp = this.$element.data('slides-' + key);
                var slides = dataBp == undefined ? dataDefault.slides : dataBp;

                slide.breakpoint = dataDefault.width;
                slide.settings.slidesToShow = slides;
                slide.settings.slidesToScroll = slides;

                conf.push(slide);
            }
        }

        return conf;
    };

    /**
     * Destroy the plugin instance.
     *
     * @function destroy
     * @returns {void}
     */
    Gallery.prototype.destroy = function() {
        this.$element.slick('unslick');

        this.$element.removeData('plugin_' + pluginName);
    };

    /**
     * Create jQuery plugin.
     *
     * @param {Object} options - Extended options.
     * @listens rkas.Gallery
     * @returns {Array<Gallery>} Array of Gallerys.
     */
    $.fn[pluginName] = function(options) {
        var args = Array.prototype.slice.call(arguments, 1);

        return this.each(function() {
            var instance = $.data(this, 'plugin_' + pluginName);

            if (!instance) {
                if (options === 'destroy') {
                    return;
                }

                $.data(this, 'plugin_' + pluginName, new Gallery(this, options));
            } else if (typeof options === 'string') {
                instance[options].apply(instance, args);
            }
        });
    };

    /**
     * @param {Event} event
     * @event enhance.rkas.Gallery
     */
    $(document).on('enhance.rkas.gallery', function(event) {
        $(event.target).find(initSelector)[pluginName]();
    });

    /**
     * @param {Event} event
     * @event destroy.rkas.Gallery
     */
    $(document).on('destroy.rkas.gallery', function(event) {
        $(event.target).find(initSelector)[pluginName]('destroy');
    });


    /**
     * Auto-init the plugin on DOM ready.
     * @fires enhance.rkas.Gallery
     */
    $(function() {
        $(document).trigger('enhance.rkas.gallery');
    });

    /**
     * Old init for compatibility.
     *
     * @fires enhance.rkas.Gallery
     * @deprecated Use enhance.rkas.Gallery event directly.
     * @returns {void}
     */
    function initGallery() {
        $(document).trigger('enhance.rkas.gallery');
    }
    window.initGallery = initGallery;

})(jQuery, window, document);


